import {process} from "@progress/kendo-data-query";
import Waiting from "../waiting/Waiting";
import {TextBox} from "@progress/kendo-react-inputs";
import {Button} from "@progress/kendo-react-buttons";
import ProjectInGrid from "./ProjectInGrid";
import useClientStore from "../../stores/ClientStore";
import useOwnRightsStore from "../../stores/OwnRightsStore";
import React, {useEffect, useState} from "react";
import useProjectStore from "../../stores/ProjectStore";
import {useNavigate} from "react-router-dom";
import * as PropTypes from "prop-types";


const initialDataState = {
    take: 500,
    skip: 0,
    sort: [
        { field: "LastActivity", dir: "desc" }
    ]
};

function Redirect(props) {
    return null;
}

Redirect.propTypes = {to: PropTypes.string};
const Projects = props => {

    // const refresh = props.refresh
    // const client = props.client
    // const selectedProject = props.project


    const {selectedClient, setSelectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient, setSelectedClient: state.selectClient}))

    const {selectedProject, setSelectedProject} = useProjectStore((state) => ({selectedProject: state.selectedItem, setSelectedProject: state.selectItem}))
    const projects = useProjectStore(state => state.storeData)
    const isPending = useProjectStore(state => state.isLoading)
    const loadProjects = useProjectStore(state => state.loadForClient)

    const rights = useOwnRightsStore(state => state.storeData)
    const haveRight = useOwnRightsStore(state => state.haveRight)

    useEffect(() => {
        // eslint-disable-next-line react-hooks/rules-of-hooks

        loadProjects(selectedClient.ID)
        console.log("load projects", selectedClient.ID)
        // setSelectedProject(null)
        console.log(projects)
    },[])

    const [dataState, setDataState] = useState(initialDataState);
    const [filter, setFilter] = useState("")

    const useFilter = (e) => {
        setFilter(e.value)

        const newDataState = {
            take: 500,
            skip: 0,
            filter: {
                logic: "or",
                filters: [
                    { field: "Name", operator: "contains", value: e.value },
                ]
            },
            sort: [
                { field: "LastActivity", dir: "desc" }
            ]
        };

        setDataState(newDataState)

    }


    const navigate = useNavigate();
    const selectProject = project => {
        props.setOpenNew(true)
        setSelectedProject(project)
        navigate("/tms")
    }

    return(
        <>

            {isPending && <Waiting />}

            {projects && <>

                <div className="clients">

                    <div className="quick-filter">
                        <TextBox value={filter}
                                 onChange={useFilter}
                                 size={"large"}
                                 style={{
                                     width: "calc(100% - 40px)",
                                     marginBottom: 3,
                                     marginTop: 3,
                                     padding: 0,
                                     color: "#333333",
                                     background: "#DDDDDD",
                                 }}
                        />&nbsp;
                    </div>

                    <div className="list">
                        {process(projects, dataState).data.map(project => (
                            <ProjectInGrid key={project.ID} id={project.ID} project={project} selectedProject={selectedProject} selectProject={selectProject}/>
                        ))}
                    </div>

                </div>
            </>}
        </>
    )
}

export default Projects